import { InputTypeContext } from '@/contexts/InputTypeContext';
import { useContext } from 'react';

export const useInputType = () => {
  const context = useContext(InputTypeContext);

  if (!context) throw new Error('Context가 초기화되지 않았습니다.');

  return context;
};
